import { useState, useEffect, useRef } from 'react';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import './Users.css';
import ModalUser from './ModalUser';
import profiles from '../../utils/profileUtils';
import userStatus from '../../utils/userStatusUtils';
import '@aws-amplify/ui-react/styles.css';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import PulseLoader from 'react-spinners/PulseLoader';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Modal from '../../components/common/Modal';
import * as moment from 'moment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { SubjectLayout } from 'layouts/SubjectLayout';
import { Table } from 'components/Table';
import {
  ROLE,
  UNIT,
  CHANNEL,
  USER_STATUS,
  NAME_OR_EMAIL,
} from 'constants/filters/fields';
import { useTableFilterStore } from 'store/tableFilterStore';
import { useNotification } from 'hooks/useNotification';
import { channelAPI, unitAPI, usersAPI } from 'services/admin';

function Users(props) {
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState('');
  const [auth] = useOutletContext();
  const [userProps, setUserProps] = useState({});
  const [searchParams] = useSearchParams();
  const { userPageFilters, setUserPageFilters } = useTableFilterStore();

  useEffect(() => {
    getUnitsFilter();
    getChannelsFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpen = action => {
    setAction(action);
    setOpen(true);
  };

  const [totalItems, setTotalItems] = useState(); //total de resultados retornado pela consulta de usuários
  const [totalPages, setTotalPages] = useState(); //total de páginas que temos para exibir

  const [itemsPerPage, setItemsPerPage] = useState(); //exibicao da posicao de itens que está sendo exibido no footer da página
  const [itemsInitialPage, setItemsInitialPage] = useState(1);

  const [actualPage, setActualPage] = useState(1); //numero exibido indicando qual a pagina atual que ele está

  const [userItems, setUserItems] = useState([]); //resultado da consulta

  const { setNotify } = useNotification();
  const offSetItems = useRef(0);

  const [filterPath, setFilterPath] = useState(() => {
    if (!searchParams?.size && userPageFilters.qs) {
      return `&${userPageFilters.qs}`;
    }

    if (!searchParams?.size) return '';

    let queryPath = '';
    const channel =
      searchParams.get('canal') && JSON.parse(searchParams.get('canal'));
    const unit =
      searchParams.get('unidade') && JSON.parse(searchParams.get('unidade'));

    if (channel) queryPath += `&channelId=${channel.value}`;
    if (unit) queryPath += `&unitId=${unit.value}`;

    return queryPath || '';
  });

  const [initialFilter] = useState(() => {
    if (!searchParams?.size && userPageFilters.object) {
      return userPageFilters.object;
    }
    if (!searchParams?.size) return;

    const filterInitialArray = [];
    const channel =
      searchParams.get('canal') && JSON.parse(searchParams.get('canal'));

    channel &&
      filterInitialArray.push({
        field: 'channel',
        label: 'Canal',
        chipValue: channel.label,
        value: channel.value,
      });

    const unit =
      searchParams.get('unidade') && JSON.parse(searchParams.get('unidade'));

    unit &&
      filterInitialArray.push({
        field: 'unit',
        label: 'Unidade',
        chipValue: unit.label,
        value: unit.value,
      });

    return filterInitialArray;
  });

  //UNITS
  const [, setFilterUnits] = useState([]);
  const [, setIsFilterUnitsLoading] = useState(false);
  //CHANNELS
  const [, setFilterChannels] = useState([]);
  const [, setIsFilterChannelsLoading] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const { showConfirmationButton } = useState(true);

  const [pending, setPending] = useState();

  //FILTERS API CALL
  //UNITS
  async function getUnitsFilter() {
    setIsFilterUnitsLoading(true);

    unitAPI
      .get()
      .then(resp => {
        setFilterUnits(
          resp['unitList'].map(unit => {
            return {
              value: unit.id,
              label: unit.name,
            };
          })
        );
        // resolve(allUnits)

        // setIsLoading(false)
        setIsFilterUnitsLoading(false);
      })
      .catch(error => {
        console.log(error);
        // setIsLoading(false)
      });
  }
  //CHANNELS
  async function getChannelsFilter() {
    setIsFilterChannelsLoading(true);

    channelAPI
      .get()
      .then(resp => {
        setFilterChannels(
          resp['channelList'].map(channel => {
            return {
              value: channel.id,
              label: channel.name,
            };
          })
        );
        // resolve(allChannels)

        // setIsLoading(false)
        setIsFilterChannelsLoading(false);
      })
      .catch(error => {
        console.log(error);
        // setIsLoading(false)
      });
  }

  //STATUS (PROFILES DONT NEED TO BE LOADED FROM THE DATABASE)
  const statusOptions = Object.keys(userStatus).map(status => ({
    value: status,
    label: userStatus[status],
  }));

  const handleResendPassword = async (userId, userEmail) => {
    const path = `/${userId}/resend-password`;

    try {
      usersAPI.patch(path).then(() =>
        setNotify({
          isOpen: true,
          message: `Email enviado para "${userEmail}."`,
          type: 'success',
          title: 'Sucesso!',
        })
      );
      setConfirmDialogAction({ isOpen: false });
    } catch (err) {
      console.log(err);
    }
  };

  const handleUserStatusChange = async (userId, value, userName) => {
    const statusValueChange = value === 'ACTIVE' ? 'active' : 'inactive';
    const path = `/${userId}/status/${statusValueChange}`;

    usersAPI
      .put(path)
      .then(() => {
        if (statusValueChange === 'active') {
          setNotify({
            isOpen: true,
            message: `Usuário "${userName}" ativado.`,
            type: 'success',
            title: 'Sucesso!',
          });
        } else if (statusValueChange === 'inactive') {
          setNotify({
            isOpen: true,
            message: `Usuário "${userName}" desativado.`,
            type: 'success',
            title: 'Sucesso!',
          });
        }
        userDataTableGetItems();
      })
      .catch(err => console.log(err));
  };

  const handleButtonClick = (e, id) => {
    e.preventDefault();
    setUserProps(id);
    handleOpen('edit');
  };

  const columns = [
    {
      id: 1,
      name: 'Nome',
      selector: row => row.name,
      width: '18%',
      sortable: true,
    },
    {
      id: 2,
      name: 'E-mail',
      selector: row => row.email,
      width: '20%',
    },
    {
      id: 3,
      name: 'Unidade',
      selector: row =>
        row.units === undefined
          ? 'datatable_prevent_click'
          : row.units.length === 0
            ? 'datatable_prevent_click'
            : row.units.length,
      width: '8%',
      center: 'true',
      cell: row => (
        <div
          className={
            row.units === undefined
              ? 'datatable_prevent_click'
              : row.units.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O usuário "{row.name}" está associado as seguintes unidades:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.units.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/unidades_sesc_icon.svg"
                          alt="Unidades Associadas"
                          style={{ width: '30px', height: '35px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Unidades associadas ({row.units.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.units === undefined
            ? '-'
            : row.units.length === 0
              ? '-'
              : row.units.length}
        </div>
      ),
    },
    {
      id: 4,
      name: 'Canal',
      selector: row =>
        row.channels === undefined
          ? 'datatable_prevent_click'
          : row.channels.length === 0
            ? 'datatable_prevent_click'
            : row.channels.length,
      width: '8%',
      center: 'true',
      cell: row => (
        <div
          className={
            row.channels === undefined
              ? 'datatable_prevent_click'
              : row.channels.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O usuário "{row.name}" está associado aos seguintes canais:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.channels.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/canais_sesc_icon.svg"
                          alt="Canais associados"
                          style={{ width: '20px', height: '25px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Canais associados ({row.channels.length}).
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.channels === undefined
            ? '-'
            : row.channels.length === 0
              ? '-'
              : row.channels.length}
        </div>
      ),
    },
    {
      id: 5,
      name: 'Perfil',
      selector: row => profiles[row.role],
      width: '10%',
    },
    {
      id: 6,
      name: 'Última Atualização',
      selector: row => moment(row.updatedAt).format('HH:mm DD/MM/YYYY'),
      width: '14%',
      center: 'true',
    },
    {
      id: 7,
      name: 'Status',
      width: '12%',
      cell: row => (
        <div>
          {row.status === 'ACTIVE' || row.status === 'INACTIVE' ? (
            <Select
              options={[statusOptions[0], statusOptions[1]]}
              defaultValue={[
                { label: userStatus[row.status], value: row.status },
              ]}
              onChange={e =>
                handleUserStatusChange(row.userId, e.value, row.name)
              }
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  //border: "none",
                  width: '110px',
                  outline: 'none',
                  padding: 0,
                  margin: 0,
                  textAlign: 'left',
                  borderColor:
                    row.status === 'ACTIVE'
                      ? '#4dd80d'
                      : row.status === 'INACTIVE'
                        ? '#e04206'
                        : '',
                }),
              }}
            />
          ) : (
            userStatus[row.status]
          )}
        </div>
      ),
    },
    {
      name: '',
      width: '5%',
      cell: row => (
        <div
          className="user_datatable_pointer"
          onClick={e => handleButtonClick(e, row)}>
          <img
            src="/img/datatable_edit_icon.svg"
            alt="Logo"
            style={{ width: '25px', height: '25px' }}
          />
        </div>
      ),
    },
    {
      name: '',
      width: '5%',
      cell: row => (
        <div
          className="user_datatable_pointer"
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              title: `Reenviar confirmação para ${row.name} ?`,
              subTitle: 'Reenvio de redefinição de senha por email.',
              children: (
                <div className="modalResendSentEmail">
                  <InfoOutlinedIcon color="primary" fontSize="12px" />
                </div>
              ),
              confirmTextButton: 'Reenviar',
              onConfirm: () => {
                handleResendPassword(row.userId, row.email);
              },
              showConfirmationButton: { showConfirmationButton },
              closeTextButton: 'Cancelar',
            })
          }>
          {row.status === 'ACTIVE' || row.status === 'INACTIVE' ? (
            ''
          ) : (
            <img
              src="/img/datatable_email_icon.svg"
              alt="Logo"
              style={{ width: '20px', height: '20px' }}
            />
          )}
        </div>
      ),
    },
  ];

  const userDataTablePagination = arrowDirection => {
    setPending(true);
    if (arrowDirection === 'right') {
      offSetItems.current += 10;
    } else if (arrowDirection === 'left') {
      offSetItems.current -= 10;
    }

    const path =
      '?limit=10&sortBy=name&offset=' + offSetItems.current + filterPath;

    usersAPI
      .get(path)
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.userList);

        if (arrowDirection === 'right') {
          setItemsInitialPage(itemsInitialPage + 10);
          setActualPage(actualPage + 1);
          setItemsPerPage(itemsPerPage + resp.userList.length);
          setPending(false);
        } else if (arrowDirection === 'left') {
          setItemsPerPage(itemsPerPage - userItems.length);
          setItemsInitialPage(itemsInitialPage - 10);
          setActualPage(actualPage - 1);
          setPending(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  useEffect(() => {
    // Este trecho de código será executado após filterPath ser atualizado
    setActualPage(1);
    setItemsInitialPage(1);
    userDataTableGetItems();
    offSetItems.current = 0;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPath]);

  const userDataTableGetItems = () => {
    setPending(true);
    setActualPage(1);
    setItemsInitialPage(1);
    offSetItems.current = 0;
    setPending(true);
    const path =
      '?limit=10&sortBy=name&offset=' + offSetItems.current + filterPath;

    usersAPI
      .get(path)
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.userList);

        if (resp.userList.length === 0) {
          setItemsInitialPage(0);
        }

        if (resp.totalItemsCountFiltered <= 10) {
          setItemsPerPage(resp.totalItemsCountFiltered);
          setTotalPages(1);
        } else {
          setItemsPerPage(resp.userList.length);
          setTotalPages(Math.ceil(resp.totalItemsCountFiltered / 10));
        }
        setPending(false);
      })
      .catch(error => {
        console.log(error);
        setPending(false);
      });
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: '50px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#475467',
        fontWeight: '500',
        backgroundColor: 'var(--gray-50, #F9FAFB)',
        // borderBottom: '1px solid var(--gray-200, #EAECF0)',
        width: 'auto',
      },
    },
    cells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#6F6B7D',
        // backgroundColor: '#EAECF0',
        width: 'auto',
      },
    },
  };

  return (
    <SubjectLayout.Root>
      <SubjectLayout.Title>Gestão de Usuários</SubjectLayout.Title>
      <SubjectLayout.IconButton
        onClick={() => {
          setUserProps({});
          handleOpen('create');
        }}>
        Usuário
      </SubjectLayout.IconButton>
      <SubjectLayout.InnerContainer>
        <div className="datatable_content">
          <div className="user_data_table_title">Usuários</div>
          <Table.Filters
            filters={[NAME_OR_EMAIL, UNIT, CHANNEL, ROLE, USER_STATUS]}
            currentFilterValues={initialFilter}
            onSubmit={(filter, filterObject) => {
              setUserPageFilters({
                qs: filter,
                object: filterObject,
              });

              setFilterPath(filter ? `&${filter}` : '');
            }}
          />
          <div className="user_datatable_width">
            <DataTable
              columns={columns}
              data={userItems}
              customStyles={customStyles}
              progressPending={pending}
              progressComponent={
                <p className="user_datatable_loading">
                  Buscando Informações...{' '}
                  <PulseLoader
                    color="#1361A4"
                    className="user_datatable_loader"
                  />
                </p>
              }
              highlightOnHover
              noDataComponent={
                <div className="user_datatable_loading">
                  <div>
                    <svg
                      width="27"
                      height="24"
                      viewBox="0 0 27 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        id="Vector"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.3805 15.2341C23.0181 15.2341 23.3823 14.5064 23 13.9961L21 10.9961C20.5375 10.2277 19.7062 9.7578 18.8094 9.7578H7.62658C7.07618 9.7578 6.56235 10.0334 6.25792 10.492L4.5667 13.0393C4.56552 13.0411 4.5668 13.0435 4.56893 13.0435C4.57107 13.0435 4.57234 13.0459 4.57117 13.0476L3.85 14.1388C3.53979 14.6081 3.87636 15.234 4.43896 15.234H7.75886C9.13473 15.234 10.2013 16.4939 11.1434 17.4966C11.7356 18.1268 12.5724 18.5197 13.5001 18.5197C14.4626 18.5197 15.3275 18.0967 15.9225 17.4245C16.7988 16.4347 17.8217 15.234 19.1437 15.234L22.3805 15.2341ZM25.8324 14.2286C26.2678 14.8843 26.5 15.654 26.5 16.4411V19.9961C26.5 22.2052 24.7091 23.9961 22.5 23.9961H4.5C2.29086 23.9961 0.5 22.2052 0.5 19.9961V16.4412C0.5 15.654 0.732258 14.8843 1.16768 14.2285L4.40363 9.35504C5.14488 8.23868 6.3959 7.56766 7.73594 7.56766H19.2644C20.6045 7.56766 21.8556 8.23874 22.5968 9.35518L25.8324 14.2286ZM9.87597 19.3045C8.83173 18.3534 7.61948 17.4246 6.20703 17.4246H4.85678C3.64704 17.4246 2.66636 18.4053 2.66636 19.6151C2.66636 20.8248 3.64704 21.8055 4.85678 21.8055H22.1423C23.352 21.8055 24.3327 20.8248 24.3327 19.6151C24.3327 18.4053 23.352 17.4246 22.1423 17.4246H20.7921C19.3796 17.4246 18.1673 18.3535 17.1229 19.3044C16.1631 20.1784 14.8925 20.7103 13.4991 20.7103C12.1056 20.7103 10.8355 20.1784 9.87597 19.3045ZM14.5832 4.29368C14.5832 4.89195 14.0982 5.37695 13.4999 5.37695C12.9016 5.37695 12.4166 4.89195 12.4166 4.29368V2.07936C12.4166 1.48109 12.9016 0.996094 13.4999 0.996094C14.0982 0.996094 14.5832 1.48109 14.5832 2.07936V4.29368ZM20.4458 5.20593C20.068 5.67893 19.3767 5.7525 18.9077 5.36962C18.4458 4.99246 18.3736 4.31374 18.7458 3.84781L20.0124 2.26227C20.3903 1.78928 21.0816 1.71571 21.5505 2.09859C22.0125 2.47575 22.0847 3.15447 21.7125 3.6204L20.4458 5.20593ZM8.25399 3.84781C8.6262 4.31373 8.55397 4.99246 8.09204 5.36962C7.62309 5.7525 6.9318 5.67893 6.55393 5.20593L5.2873 3.6204C4.91508 3.15447 4.98731 2.47575 5.44925 2.09859C5.91819 1.71571 6.60949 1.78928 6.98735 2.26227L8.25399 3.84781Z"
                        fill="#344054"
                      />
                    </svg>
                  </div>
                  <p className="datatable_nodata_text">
                    Não encontramos registros para os dados informados.
                  </p>
                </div>
              }
              defaultSortFieldId={1}
              defaultSortAsc={true}
              sortIcon={<ArrowDropDownIcon color="#1361A4" />}></DataTable>
          </div>
          <div className="user_data_table_footer">
            <div className="user_data_table_footer_total">
              {itemsInitialPage} - {itemsPerPage} de {totalItems}
            </div>
            <div className="user_data_table_footer_pages">
              <KeyboardArrowLeftIcon
                className={
                  actualPage == 1
                    ? 'user_datatable_disabled_left_arrow'
                    : 'user_datatable_left_arrow'
                }
                onClick={() => userDataTablePagination('left')}
              />
              {actualPage}
              <KeyboardArrowRightIcon
                className={
                  totalItems <= 10
                    ? 'user_datatable_disabled_right_arrow'
                    : actualPage === totalPages
                      ? 'user_datatable_disabled_right_arrow'
                      : 'user_datatable_right_arrow'
                }
                onClick={() => userDataTablePagination('right')}
              />
            </div>
          </div>
        </div>
      </SubjectLayout.InnerContainer>
      <ModalUser
        open={open}
        authenticatedUser={auth}
        action={action}
        user={userProps}
        onClose={() => setOpen(false)}
        getUsers={userDataTableGetItems}
      />
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
        showConfirmationButton={showConfirmationButton}
      />
    </SubjectLayout.Root>
  );
}

export default Users;
